'use es6';

import I18n from 'I18n';
import getTranslatedTimezoneGroups from 'timezone-utils/utils/getTranslatedTimezoneGroups';
import groupsToSelectOpts from 'timezone-utils/utils/groupsToSelectOpts';
var previousLocale;
var options;
var optionsMap;
export default function () {
  var shouldRefetch = I18n.locale !== previousLocale;
  previousLocale = I18n.locale;

  if (!options || shouldRefetch) {
    options = groupsToSelectOpts(getTranslatedTimezoneGroups());
    optionsMap = options.reduce(function (accI, optionGroup) {
      return optionGroup.options.reduce(function (accJ, option) {
        accJ[option.value] = option.text;
        return accJ;
      }, accI);
    }, {});
  }

  return {
    options: options,
    optionsMap: optionsMap
  };
}